// GENERATED by scripts/check-icons.mjs — do not edit by hand (run it with --write).
// Every Ionicon the app renders, registered once at bootstrap (see main.ts). Named imports keep
// the bundle to exactly these icons instead of the whole set.
import { addIcons } from 'ionicons';
import {
  add,
  addCircle,
  addCircleOutline,
  addOutline,
  alertCircle,
  alertCircleOutline,
  archiveOutline,
  arrowBackCircleOutline,
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  arrowRedoOutline,
  arrowUpCircleOutline,
  atOutline,
  bag,
  bagHandleOutline,
  bookmarkOutline,
  briefcaseOutline,
  buildOutline,
  business,
  businessOutline,
  calendar,
  calendarClearOutline,
  calendarOutline,
  callOutline,
  camera,
  cameraOutline,
  cardOutline,
  caretUp,
  cartOutline,
  chatbubbleEllipsesOutline,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDoneOutline,
  checkmarkOutline,
  chevronBack,
  chevronBackOutline,
  chevronDown,
  chevronDownOutline,
  chevronExpandOutline,
  chevronForward,
  chevronForwardOutline,
  chevronUp,
  chevronUpOutline,
  clipboardOutline,
  close,
  closeCircle,
  closeCircleOutline,
  closeOutline,
  cloudOfflineOutline,
  cloudUploadOutline,
  codeOutline,
  codeSlashOutline,
  compassOutline,
  copyOutline,
  createOutline,
  cubeOutline,
  documentOutline,
  documentTextOutline,
  downloadOutline,
  ellipse,
  ellipseOutline,
  ellipsisHorizontal,
  ellipsisVertical,
  ellipsisVerticalOutline,
  eye,
  eyeOff,
  eyeOutline,
  fingerPrintOutline,
  flagOutline,
  giftOutline,
  gridOutline,
  hammerOutline,
  heart,
  heartCircleOutline,
  heartOutline,
  helpCircleOutline,
  hourglassOutline,
  imageOutline,
  informationCircleOutline,
  key,
  keyOutline,
  link,
  linkOutline,
  listOutline,
  locationOutline,
  lockClosed,
  lockClosedOutline,
  logOutOutline,
  logoAndroid,
  logoApple,
  logoFacebook,
  logoInstagram,
  logoLinkedin,
  logoWhatsapp,
  logoX,
  mailOutline,
  megaphoneOutline,
  moonOutline,
  notifications,
  notificationsOffOutline,
  notificationsOutline,
  openOutline,
  paperPlaneOutline,
  pauseCircle,
  pencilOutline,
  people,
  peopleOutline,
  person,
  personAddOutline,
  personCircleOutline,
  personOutline,
  phonePortraitOutline,
  playOutline,
  pricetagOutline,
  qrCode,
  qrCodeOutline,
  receiptOutline,
  refresh,
  refreshOutline,
  removeOutline,
  repeat,
  repeatOutline,
  saveOutline,
  searchOutline,
  serverOutline,
  settingsOutline,
  shareOutline,
  shareSocialOutline,
  shirtOutline,
  sparklesOutline,
  starOutline,
  statsChart,
  statsChartOutline,
  stopCircleOutline,
  storefront,
  storefrontOutline,
  sunny,
  sunnyOutline,
  swapHorizontal,
  swapHorizontalOutline,
  sync,
  ticketOutline,
  timeOutline,
  trashOutline,
  trendingUpOutline,
  trophyOutline,
  unlinkOutline,
  videocamOutline,
  walletOutline,
  warningOutline,
  wifiOutline,
} from 'ionicons/icons';

export const APP_ICON_NAMES: readonly string[] = [
  'add',
  'add-circle',
  'add-circle-outline',
  'add-outline',
  'alert-circle',
  'alert-circle-outline',
  'archive-outline',
  'arrow-back-circle-outline',
  'arrow-back-outline',
  'arrow-forward',
  'arrow-forward-outline',
  'arrow-redo-outline',
  'arrow-up-circle-outline',
  'at-outline',
  'bag',
  'bag-handle-outline',
  'bookmark-outline',
  'briefcase-outline',
  'build-outline',
  'business',
  'business-outline',
  'calendar',
  'calendar-clear-outline',
  'calendar-outline',
  'call-outline',
  'camera',
  'camera-outline',
  'card-outline',
  'caret-up',
  'cart-outline',
  'chatbubble-ellipses-outline',
  'checkmark',
  'checkmark-circle',
  'checkmark-circle-outline',
  'checkmark-done-outline',
  'checkmark-outline',
  'chevron-back',
  'chevron-back-outline',
  'chevron-down',
  'chevron-down-outline',
  'chevron-expand-outline',
  'chevron-forward',
  'chevron-forward-outline',
  'chevron-up',
  'chevron-up-outline',
  'clipboard-outline',
  'close',
  'close-circle',
  'close-circle-outline',
  'close-outline',
  'cloud-offline-outline',
  'cloud-upload-outline',
  'code-outline',
  'code-slash-outline',
  'compass-outline',
  'copy-outline',
  'create-outline',
  'cube-outline',
  'document-outline',
  'document-text-outline',
  'download-outline',
  'ellipse',
  'ellipse-outline',
  'ellipsis-horizontal',
  'ellipsis-vertical',
  'ellipsis-vertical-outline',
  'eye',
  'eye-off',
  'eye-outline',
  'finger-print-outline',
  'flag-outline',
  'gift-outline',
  'grid-outline',
  'hammer-outline',
  'heart',
  'heart-circle-outline',
  'heart-outline',
  'help-circle-outline',
  'hourglass-outline',
  'image-outline',
  'information-circle-outline',
  'key',
  'key-outline',
  'link',
  'link-outline',
  'list-outline',
  'location-outline',
  'lock-closed',
  'lock-closed-outline',
  'log-out-outline',
  'logo-android',
  'logo-apple',
  'logo-facebook',
  'logo-instagram',
  'logo-linkedin',
  'logo-whatsapp',
  'logo-x',
  'mail-outline',
  'megaphone-outline',
  'moon-outline',
  'notifications',
  'notifications-off-outline',
  'notifications-outline',
  'open-outline',
  'paper-plane-outline',
  'pause-circle',
  'pencil-outline',
  'people',
  'people-outline',
  'person',
  'person-add-outline',
  'person-circle-outline',
  'person-outline',
  'phone-portrait-outline',
  'play-outline',
  'pricetag-outline',
  'qr-code',
  'qr-code-outline',
  'receipt-outline',
  'refresh',
  'refresh-outline',
  'remove-outline',
  'repeat',
  'repeat-outline',
  'save-outline',
  'search-outline',
  'server-outline',
  'settings-outline',
  'share-outline',
  'share-social-outline',
  'shirt-outline',
  'sparkles-outline',
  'star-outline',
  'stats-chart',
  'stats-chart-outline',
  'stop-circle-outline',
  'storefront',
  'storefront-outline',
  'sunny',
  'sunny-outline',
  'swap-horizontal',
  'swap-horizontal-outline',
  'sync',
  'ticket-outline',
  'time-outline',
  'trash-outline',
  'trending-up-outline',
  'trophy-outline',
  'unlink-outline',
  'videocam-outline',
  'wallet-outline',
  'warning-outline',
  'wifi-outline',
];

export function registerAppIcons(): void {
  addIcons({
    add,
    addCircle,
    addCircleOutline,
    addOutline,
    alertCircle,
    alertCircleOutline,
    archiveOutline,
    arrowBackCircleOutline,
    arrowBackOutline,
    arrowForward,
    arrowForwardOutline,
    arrowRedoOutline,
    arrowUpCircleOutline,
    atOutline,
    bag,
    bagHandleOutline,
    bookmarkOutline,
    briefcaseOutline,
    buildOutline,
    business,
    businessOutline,
    calendar,
    calendarClearOutline,
    calendarOutline,
    callOutline,
    camera,
    cameraOutline,
    cardOutline,
    caretUp,
    cartOutline,
    chatbubbleEllipsesOutline,
    checkmark,
    checkmarkCircle,
    checkmarkCircleOutline,
    checkmarkDoneOutline,
    checkmarkOutline,
    chevronBack,
    chevronBackOutline,
    chevronDown,
    chevronDownOutline,
    chevronExpandOutline,
    chevronForward,
    chevronForwardOutline,
    chevronUp,
    chevronUpOutline,
    clipboardOutline,
    close,
    closeCircle,
    closeCircleOutline,
    closeOutline,
    cloudOfflineOutline,
    cloudUploadOutline,
    codeOutline,
    codeSlashOutline,
    compassOutline,
    copyOutline,
    createOutline,
    cubeOutline,
    documentOutline,
    documentTextOutline,
    downloadOutline,
    ellipse,
    ellipseOutline,
    ellipsisHorizontal,
    ellipsisVertical,
    ellipsisVerticalOutline,
    eye,
    eyeOff,
    eyeOutline,
    fingerPrintOutline,
    flagOutline,
    giftOutline,
    gridOutline,
    hammerOutline,
    heart,
    heartCircleOutline,
    heartOutline,
    helpCircleOutline,
    hourglassOutline,
    imageOutline,
    informationCircleOutline,
    key,
    keyOutline,
    link,
    linkOutline,
    listOutline,
    locationOutline,
    lockClosed,
    lockClosedOutline,
    logOutOutline,
    logoAndroid,
    logoApple,
    logoFacebook,
    logoInstagram,
    logoLinkedin,
    logoWhatsapp,
    logoX,
    mailOutline,
    megaphoneOutline,
    moonOutline,
    notifications,
    notificationsOffOutline,
    notificationsOutline,
    openOutline,
    paperPlaneOutline,
    pauseCircle,
    pencilOutline,
    people,
    peopleOutline,
    person,
    personAddOutline,
    personCircleOutline,
    personOutline,
    phonePortraitOutline,
    playOutline,
    pricetagOutline,
    qrCode,
    qrCodeOutline,
    receiptOutline,
    refresh,
    refreshOutline,
    removeOutline,
    repeat,
    repeatOutline,
    saveOutline,
    searchOutline,
    serverOutline,
    settingsOutline,
    shareOutline,
    shareSocialOutline,
    shirtOutline,
    sparklesOutline,
    starOutline,
    statsChart,
    statsChartOutline,
    stopCircleOutline,
    storefront,
    storefrontOutline,
    sunny,
    sunnyOutline,
    swapHorizontal,
    swapHorizontalOutline,
    sync,
    ticketOutline,
    timeOutline,
    trashOutline,
    trendingUpOutline,
    trophyOutline,
    unlinkOutline,
    videocamOutline,
    walletOutline,
    warningOutline,
    wifiOutline,
  });
}
